module.exports = require("ember-get-config");